import React, { ReactNode } from 'react';

export interface Props {
  id?: string;
  className?: string;
  src: string | ReactNode;
}

export const Image = (props: Props) => {
  const { src, ...rest } = props;

  if (React.isValidElement(src)) {
    return src;
  }

  return <>{src && <img {...rest} src={src as string} />}</>;
};
